import { IErrorMessage } from '@hooks/use-error-message.ts';
import interlinkImage from '@assets/images/integrations/interlink.jpg';

export type DialogType = 'iptvProvider' | 'm3u8' | null;

export const steps = [
  'entertainment_live_tv_import_iptv_provider_step1_title',
  'entertainment_live_tv_import_iptv_provider_step2_title'
];

export const liveTvErrorMessages: IErrorMessage = {
  title: {
    required: 'validation_title_required',
    notOnlySpaces: 'validation_notOnly_spaces_required'
  },
  image: {
    // required: 'validation_image_required'
  },
  channelNumber: {
    required: 'validation_channel_number_required'
  },
  url: {
    required: 'validation_url_required',
    pattern: 'validation_url_pattern',
    notOnlySpaces: 'validation_notOnly_spaces_required'
  },
  country: {
    required: 'validation_country_required'
  },
  language: {
    required: 'validation_language_required'
  },
  player: {
    required: 'validation_player_required'
  }
};

export const playerOptions = [
  { id: 1, title: 'Exo', value: 'Exo' },
  { id: 2, title: 'VLC', value: 'VLC' }
];

export const handleSortData = (data: any, categoriesList: any) => {
  return {
    ...data,
    title: data.title,
    channelNumber: data.channelNumber,
    language: data.language.title,
    categories: categoriesList.map((item: any) => item.id),
    country: data.country.title,
    url: data.url,
    player: data.player?.value || playerOptions[0].value
  };
};

export const internetProviderInterlinkData = {
  id: 'inter-link',
  name: 'Interlink',
  description:
    'Interlink is a broadband and digital TV service provider offering a rich catalog of live channels.\n' +
    'Choose Interlink to automatically import the latest channel lineup and metadata directly from their service.',
  image: interlinkImage
};

export const LiveTvStatusMap: Record<
  'true' | 'false',
  { text: string; color: string }
> = {
  true: {
    text: 'Enabled',
    color: 'var(--green-4)'
  },
  false: {
    text: 'Disabled',
    color: 'var(--pink)'
  }
};

export const liveTvFilterStatusOptions = [
  { title: 'Enabled', value: true },
  { title: 'Disabled', value: false }
];
